import React from 'react';
import _ from 'lodash';

import { ImportCsvModal } from 'iron-forge-react-modules';
import * as importCsvSettings from './importCsvSettings';
import * as dataService from './dataService';
import * as types from './types';



const ImportCsvModalComponent = ImportCsvModal.genComponent<types.NetSuiteDepartmentsPropertyName>();

export interface IProps {
  onCancel: () => void;
  onAccept: () => void;
}

export const FC: React.FC<IProps> = props => {
  const [importNetSuiteDepartmentsFromCsv, importNetSuiteDepartmentsFromCsvTuple] = dataService.useImportNetSuiteDepartmentsFromCsv();

  const processImport = React.useCallback(
    async (rows: Array<_.Dictionary<string>>) => {
      importNetSuiteDepartmentsFromCsv(rows);
    },
    [
      importNetSuiteDepartmentsFromCsv
    ]
  );

  const loading = importNetSuiteDepartmentsFromCsvTuple.loading;

  return (
    <ImportCsvModalComponent
      isOpen
      isLoading={loading}
      title="Import Net Suite Departments"
      columnDescriptions={dataService.columnDefs}
      formatType2Comment={importCsvSettings.propertyName2Comment}
      formatType2Data={importCsvSettings.propertyName2Data}
      fnImport={processImport}
      onCancel={props.onCancel}
      onAccept={props.onAccept} />
  );
};
